import { render, staticRenderFns } from "./StockTrfList.vue?vue&type=template&id=c9c99e64&"
import script from "./StockTrfList.vue?vue&type=script&lang=js&"
export * from "./StockTrfList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports